module.exports = __webpack_public_path__ + "media/images/emblems/Ellikon_an_der_Thur-blazon-1c530411ad207995986c104e2e53167c.svg";